export const API = {
  USER_LIST_API: 'https://randomuser.me/api/?results=50',
};

export const PAGE = {
  USERS: 'users',
};

export const API_TO_PAGE_MAP = {
  [API.USER_LIST_API]: PAGE.USERS,
};
